export function ReadPropsUserHaveAsset(action, self, onReadSuccess, onReadFailed, filter, order, page) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    action : action,
    self: self,
    onsuccess : onReadSuccess,
    onfailed : onReadFailed,
    filter: filter,
    order:order,
    page:page
   }
}
export function ReadPropsUserAsset(action, self, onReadSuccess, onReadFailed, selectedData = null, nextUrl = null) {
  return {
    data : {
      AuthorizationToken : self.props.UserReducer.token,
    },
    action : action,
    self: self,
    NextUrl : nextUrl,
    selectedData: selectedData,
    onsuccess : onReadSuccess,
    onfailed : onReadFailed,
   }
}


// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/helper/request.props.js